document.addEventListener('DOMContentLoaded',()=> {
  document.querySelectorAll('[data-back-link]').forEach(button=>button.addEventListener('click',()=> {
    try{
      const ref=document.referrer?new URL(document.referrer):null;
      if(ref&&ref.origin===window.location.origin&&window.history.length>1) window.history.back();
      else window.location.href='/';
    }catch(error){window.location.href='/';}
  }));
  const mobileButton=document.querySelector('[data-mobile-toggle]');
  const nav=document.querySelector('[data-nav]');
  if(mobileButton&&nav){
    mobileButton.addEventListener('click',()=> {
      const open=nav.classList.toggle('is-open');
      mobileButton.setAttribute('aria-expanded',String(open));
      document.body.classList.toggle('nav-open',open);
    });
  }

  const drawer=document.querySelector('[data-cart-drawer]');
  const openButtons=document.querySelectorAll('[data-cart-open]');
  const closeButton=document.querySelector('[data-cart-close]');
  const openDrawer=()=> {if(drawer&&!drawer.open)drawer.showModal();};
  const closeDrawer=()=> {if(drawer&&drawer.open)drawer.close();};
  openButtons.forEach(button=>button.addEventListener('click',openDrawer));
  if(closeButton)closeButton.addEventListener('click',closeDrawer);
  if(drawer)drawer.addEventListener('click',event=> {if(event.target===drawer)closeDrawer();});

  document.querySelectorAll('[data-product-root]').forEach(root=> {
    const select=root.querySelector('[data-variant-select]');
    const price=root.querySelector('[data-product-price]');
    const addButton=root.querySelector('[data-add-button]');
    const groups=Array.from(root.querySelectorAll('[data-option-group]'));
    const mainImage=root.querySelector('[data-product-main-image]');
    const thumbs=Array.from(root.querySelectorAll('[data-media-thumb]'));

    const variantOptions=option=> groups.map((group,index)=>option.getAttribute('data-option-'+(index+1))||'');
    const selectedValues=()=> groups.map(group=>group.querySelector('[data-option-button].is-selected')?.dataset.optionValue||'');
    const setGroupValue=(group,value)=> {
      group.querySelectorAll('[data-option-button]').forEach(button=> {
        const active=button.dataset.optionValue===value;
        button.classList.toggle('is-selected',active);
        button.setAttribute('aria-pressed',String(active));
      });
    };
    const findVariant=(values,availableOnly=false)=> {
      if(!select)return null;
      return Array.from(select.options).find(option=> {
        if(availableOnly&&option.disabled)return false;
        const optionValues=variantOptions(option);
        return values.every((value,index)=>!value||optionValues[index]===value);
      })||null;
    };
    const showMedia=option=> {
      if(!mainImage||!option)return;
      const mediaId=option.dataset.mediaId;
      const mediaSrc=option.dataset.mediaSrc;
      if(mediaSrc){
        mainImage.src=mediaSrc;
        mainImage.dataset.mediaId=mediaId||'';
      }else if(mainImage.dataset.defaultMediaSrc){
        mainImage.src=mainImage.dataset.defaultMediaSrc;
        mainImage.dataset.mediaId=mainImage.dataset.defaultMediaId||'';
      }
      thumbs.forEach(thumb=>thumb.classList.toggle('is-active',Boolean(mediaId)&&thumb.dataset.mediaId===mediaId));
    };
    const updateAvailability=()=> {
      if(!select||!groups.length)return;
      const selected=selectedValues();
      groups.forEach((group,groupIndex)=> {
        group.querySelectorAll('[data-option-button]').forEach(button=> {
          let exists=false;
          const value=button.dataset.optionValue;
          if(groupIndex===0){
            exists=Array.from(select.options).some(option=>!option.disabled&&variantOptions(option)[0]===value);
          }else{
            exists=Array.from(select.options).some(option=> {
              if(option.disabled)return false;
              const values=variantOptions(option);
              if(values[groupIndex]!==value)return false;
              return selected.every((selectedValue,index)=>index===groupIndex||!selectedValue||values[index]===selectedValue);
            });
          }
          button.disabled=!exists;
          button.classList.toggle('is-unavailable',!exists);
        });
      });
    };
    const applyVariant=option=> {
      if(!option||!select)return;
      select.value=option.value;
      select.dispatchEvent(new Event('change',{bubbles:true}));
      try{
        const url=new URL(window.location.href);
        url.searchParams.set('variant',option.value);
        window.history.replaceState({},'',url);
      }catch(error){}
      const values=variantOptions(option);
      groups.forEach((group,index)=>setGroupValue(group,values[index]));
      if(price&&option.dataset.price)price.textContent=option.dataset.price;
      if(addButton){
        const unavailable=option.disabled;
        addButton.disabled=unavailable;
        addButton.textContent=unavailable?addButton.dataset.labelSold:addButton.dataset.labelAdd;
      }
      showMedia(option);
      updateAvailability();
    };

    groups.forEach((group,groupIndex)=> {
      group.querySelectorAll('[data-option-button]').forEach(button=> {
        button.addEventListener('click',()=> {
          if(button.disabled)return;
          setGroupValue(group,button.dataset.optionValue);
          let values=selectedValues();
          let option=findVariant(values,false);
          if(!option||option.disabled){
            if(groupIndex===0){
              option=Array.from(select.options).find(candidate=>!candidate.disabled&&variantOptions(candidate)[0]===button.dataset.optionValue)||null;
            }else{
              option=findVariant(values,true);
            }
          }
          if(option)applyVariant(option);
          else updateAvailability();
        });
      });
    });

    thumbs.forEach(thumb=>thumb.addEventListener('click',()=> {
      if(!mainImage)return;
      mainImage.src=thumb.dataset.mediaSrc;
      mainImage.dataset.mediaId=thumb.dataset.mediaId||'';
      thumbs.forEach(item=>item.classList.toggle('is-active',item===thumb));
    }));

    if(select&&select.selectedOptions.length){
      applyVariant(select.selectedOptions[0]);
      root.dataset.variantPickerReady='true';
    }
  });

  document.querySelectorAll('[data-product-form]').forEach(form=> {
    form.addEventListener('submit',async event=> {
      if(!window.fetch)return;
      event.preventDefault();
      const button=form.querySelector('[type="submit"]');
      if(button){button.disabled=true;button.dataset.original=button.textContent;button.textContent='Añadiendo…';}
      try{
        const response=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        if(!response.ok)throw new Error('cart');
        const sectionResponse=await fetch('/cart?section_id=cart-drawer');
        const html=await sectionResponse.text();
        const doc=new DOMParser().parseFromString(html,'text/html');
        const fresh=doc.querySelector('[data-cart-drawer-content]');
        const current=document.querySelector('[data-cart-drawer-content]');
        if(fresh&&current)current.replaceWith(fresh);
        const cartResponse=await fetch('/cart.js');
        const cart=await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent='('+cart.item_count+')');
        openDrawer();
      }catch(error){
        form.submit();
      }finally{
        if(button){button.disabled=false;button.textContent=button.dataset.original||button.dataset.labelAdd||'Añadir al carrito';}
      }
    });
  });
});